export default {
  LEGACY_ROUTE: '/link.php?giftcards',
  PURCHASE_GIFT_CARDS_LINK: 'https://buypizzahutcards.com/Giftcard',
  THIRD_PARTY_CARD_PREFIX: '4',
  IMAGE_GIFT_CARD_WITH_LOGO: '/images/gift-card-with-logo.png'
};
